import AOS from 'aos';

import './utils/vh.utils.js';
import './utils/animate-on-view.utils';

import './components/meta/select.component.js';

import './components/marquee/_index.js';
import './components/swiper/_index.js';
import './components/cards/_index.js';
import './components/sections/_index.js';
import './components/animations/_index.js';

import './components/validation.component.js';

import './components/uploadFile.component.js';
import './components/header.component.js';
import './components/inputs.component.js';
import './components/animations.component.js';
import './components/player.component.js';
import './components/search-sec.component.js';

import './components/connect.component.js';

import './components/our-mission.component.js';
import './components/join-us.component.js';

import './components/sw-spotlight.component.js';
import './components/sw-our-vacancies.component.js';
import './components/sw-reviews.component.js';
import './components/sw-numbers.component.js';
import './components/sw-our-team.component.js';
import './components/sw-our-process.component.js';
import './components/sw-case-studies.component.js';
import './components/sw-similar-vacancies.component.js';
import './components/sw-benefits.component.js';
import './components/sw-snapshot.component.js';
import './components/sw-specializations.component.js';

import './libs/countUp.lib.js';
import './libs/smoothScrollbar.lib.js';


AOS.init({
  offset: 50,
  delay: 10,
  duration: 600,
  easing: 'ease-in-out',
  once: true,
  startEvent: 'DOMContentLoaded',
});


const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if(isSafari) document.body.classList.add('is-safari');


// Ловить функцію load() та викидає івенти до виконання та після
const originalLoad = load;

load = function (...args) {
  const url = args[0];

  const eventDetail = {
    args,
    url,
  };

  window.dispatchEvent(
    new CustomEvent('app:load:before', { detail: eventDetail })
  );

  const result = originalLoad.apply(this, args);

  window.dispatchEvent(
    new CustomEvent('app:load:after', { detail: eventDetail })
  );

  return result;
};

// window.addEventListener('app:load:before', (e) => {
//   console.log('Before load function:', e.detail);
// });
// window.addEventListener("app:load:after", (e) => {
//   console.log("After load function:", e.detail);
// });
